export default "__VITE_ASSET__K1zS6y$m__"